import { useEffect } from "react";

import { getCloudinaryUrl } from "@swiggy-private/js-utils";

import { LOTTIE_ANIMATIONS } from "@dineout-payment-success-ui/constants/LottieAnimations";
import { isCelebrationWindowActive } from "@dineout-payment-success-ui/helpers/LottieHelper";

const useCelebrationAssetsPrefetch = (enabled: boolean) => {
    useEffect(() => {
        if (!enabled || !isCelebrationWindowActive()) return;

        const soundUrl = getCloudinaryUrl(LOTTIE_ANIMATIONS.TABLE_RESERVATION_CELEBRATION_SOUND) as string;
        if (soundUrl) {
            const audio = new Audio(soundUrl);
            audio.preload = "auto";
        }

        const lottieUrl = getCloudinaryUrl(LOTTIE_ANIMATIONS.TABLE_RESERVATION_CELEBRATION) as string;
        if (lottieUrl) {
            fetch(lottieUrl).catch(() => void 0);
        }
    }, [enabled]);
};

export default useCelebrationAssetsPrefetch;
